import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/userSlice";
import { useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./LinkGrnToFreightOrder.module.css";
import Select from 'react-select';
import 'bootstrap-icons/font/bootstrap-icons.css';
import {Container, Modal, Row,Col,Form,Button,
        Table,Card,OverlayTrigger, Tooltip, Collapse } from "react-bootstrap";


const LinkGrnToFreightOrder = () => {
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const token = user?.token;
  const emp_id = user?.emp_id;
  

  const [entityList, setEntityList] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState("");

  const [finYearList, setFinYearList] = useState([]);
  const [selectedFinYear, setSelectedFinYear] = useState("");
  const [divGroupList, setDivGroupList] = useState([]);
  const [selectedDivGroup, setSelectedDivGroup] = useState("");

  const [poSeriesList, setPoSeriesList] = useState([]);
  const [selectedSeries, setSelectedSeries] = useState("");

  const [poNumbers, setPoNumbers] = useState([]);
  const [selectedPo, setSelectedPo] = useState(null);

  const [freightOrderList, setFreightOrderList] = useState([]);
  const [selectedFreightOrder, setSelectedFreightOrder] = useState(null);

  const [grns, setGrns] = useState([]);
  const [selectedGrns, setSelectedGrns] = useState([]);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [trptCodeList, setTrptCodeList] = useState([]);
  const [selectedTrptCode, setSelectedTrptCode] = useState(null);
  //const [showAllGrns, setShowAllGrns] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [filteredGrns, setFilteredGrns] = useState([]);
  const [paginatedGrns, setPaginatedGrns] = useState([]);
  const [filterFromDate, setFilterFromDate] = useState("");
  const [filterToDate, setFilterToDate] = useState("");
  const [hideBilled, setHideBilled] = useState(false);
  const [hideLinked, setHideLinked] = useState(false);
  const [showLocErrRec, SetShowLocErrRec] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterInFromDate, setFilterInFromDate] = useState("");
  const [filterInToDate, setFilterInToDate] = useState("");
  const [showErrorsModal, setShowErrorsModal] = useState(false);
  const [grnErrorSummary, setGrnErrorSummary] = useState({
    locationMismatch: 0,
    dateOutOfRange: 0,
    truckTypeMissing: 0
  });
  const [errorCounts, setErrorCounts] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showLocationErrorsOnly, setShowLocationErrorsOnly] = useState(false);
  const [showTruckTypeErrorsOnly, setShowTruckTypeErrorsOnly] = useState(false);
  const [showUnlinkedErrorsOnly, setShowUnlinkedErrorsOnly] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [loadingSelection, setLoadingSelection] = useState(false);

  const isGrnSelectable = (grn) => {
    const isNotBilled = !grn.ACC_VRNO;
  
    const isUnlinked =
      !grn.FREIGHT_ORDER_VRNO ||
      !grn.FREIGHT_ORDER_TCODE ||
      !grn.FREIGHT_ORDER_SLNO ||
      grn.FREIGHT_ORDER_VRNO !== selectedFreightOrder?.VRNO;
  
    const locationMismatch =
      grn.FROM_PLACE !== selectedFreightOrder?.FROM_PLACE ||
      grn.TO_PLACE !== selectedFreightOrder?.TO_PLACE;
  
    const truckTypeMismatch = !!grn.TRUCKTYPE_NAME;
  
    // ✅ Selectable if not billed AND (any of the 3 issues)
    return isNotBilled && (isUnlinked || locationMismatch || truckTypeMismatch);
  };
    
  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const FreightSummaryCard = ({ selectedFreightOrder, billFromDate, billToDate  }) => {
    const [open, setOpen] = useState(true);
    const fromDate = selectedFreightOrder?.FROM_DATE ? new Date(selectedFreightOrder.FROM_DATE) : null;
    const toDate = selectedFreightOrder?.TO_DATE ? new Date(selectedFreightOrder.TO_DATE) : null;

    const billFrom = billFromDate ? new Date(billFromDate) : null;
    const billTo = billToDate ? new Date(billToDate) : null;

    const isBillPeriodOutside =
    fromDate && toDate &&
      (billTo < fromDate ||  billFrom > toDate || billFrom < fromDate || billTo > toDate);

    return (
      <Card className="mt-3 shadow-sm border-primary-subtle">
        <Card.Header
          className="bg-primary bg-opacity-10 d-flex justify-content-between align-items-center"
        >
          <strong className="text-primary">
            <i className="bi bi-truck me-2" />
            Freight Order Summary
          </strong>
          {/* 🚨 Warning if billing period is outside freight order dates */}
          {isBillPeriodOutside && (
            <div className="mb-3 text-danger fw-bold">
              ⚠ Bill Period not within the Freight Order Effective Date.
              Please amend the Freight Order, if required.
            </div>
          )}
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => setOpen(!open)}
            aria-controls="freight-details-collapse"
            aria-expanded={open}
          >
            {open ? "Hide" : "Show"} Details
          </Button>
        </Card.Header>
  
        <Collapse in={open}>
          <div id="freight-details-collapse">
            <Card.Body className="py-3 px-4" style={{ backgroundColor: "#f8f9fb" }}>
              <Row className="mb-3">
                <Col md={3}>
                  <div className="text-muted small mb-1">
                    <i className="bi bi-receipt me-1" /> Freight Order No
                  </div>
                  <div><strong>{selectedFreightOrder?.VRNO}</strong></div>
                </Col>
                <Col md={3}>
                  <div className="text-muted small mb-1">
                    <i className="bi bi-calendar me-1" /> Order Date
                  </div>
                  <div><strong>{selectedFreightOrder?.VRDATE?.slice(0, 10)}</strong></div>
                </Col>
                <Col md={3}>
                  <div className="text-muted small mb-1">
                    <i className="bi bi-person-fill me-1" /> Transporter
                  </div>
                  <div><strong>{selectedFreightOrder?.ACC_NAME}</strong></div>
                </Col>
                <Col md={3}>
                  <div className="text-muted small mb-1">
                    <i className="bi bi-currency-rupee me-1" /> Rate
                  </div>
                  <div><strong className="text-success">₹ {selectedFreightOrder?.RATE}</strong></div>
                </Col>
              </Row>
  
              <Row>
                <Col md={3}>
                  <div className="text-muted small mb-1">
                    <i className="bi bi-calendar2-range me-1" /> From Date
                  </div>
                  <div><strong>{formatDate(selectedFreightOrder?.FROM_DATE)}</strong></div>
                </Col>
                <Col md={3}>
                  <div className="text-muted small mb-1">
                    <i className="bi bi-calendar2-range-fill me-1" /> To Date
                  </div>
                  <div><strong>{formatDate(selectedFreightOrder?.TO_DATE)}</strong></div>
                </Col>
                <Col md={3}>
                  <div className="text-muted small mb-1">
                    <i className="bi bi-geo-alt me-1" /> From Place
                  </div>
                  <div><strong>{selectedFreightOrder?.FROM_PLACE}</strong></div>
                </Col>
                <Col md={3}>
                  <div className="text-muted small mb-1">
                    <i className="bi bi-geo me-1" /> To Place
                  </div>
                  <div><strong>{selectedFreightOrder?.TO_PLACE}</strong></div>
                </Col>
              </Row>
            </Card.Body>
          </div>
        </Collapse>
      </Card>
    );
  };
   
  useEffect(() => {
    const fetchEntities = async () => {
      try {
        setLoading(true);
        const response = await axios.post("/api/entity/getAssignedEntity", { emp_id, token });
        setEntityList(response.data);
        const trptResponse = await axios.post("/api/frght/getTransporters", { emp_id, token });
        setTrptCodeList(trptResponse.data);

        setLoading(false);
      } catch (err) {
        console.error("Error fetching entity list", err);
      }  finally {
        setLoading(false);  // ✅ Ensure this is executed after fetch
      }
    };
    fetchEntities();
  }, [emp_id, token]);

  useEffect(() => {
    const fetchFinYears = async () => {
      if (selectedEntity) {
        try {
          setLoading(true);
          const response = await axios.post("/api/entity/getAssignedAccYear", {
            emp_id,
            entity_code: selectedEntity,
            token
          });
          setFinYearList(response.data);
          setLoading(false);
        } catch (err) {
          console.error("Error fetching financial year list", err);
        }  finally {
          setLoading(false);  // ✅ Ensure this is executed after fetch
        }
      }
    };
    fetchFinYears();
  }, [selectedEntity, emp_id, token]);

  useEffect(() => {
    if (selectedEntity) {
      const fetchDivGroup = async () => {
        try {
          setLoading(true);
          const response = await axios.post("/api/entity/getAssignedDivGroup", {
            entity_code: selectedEntity,
            emp_id,
            token
          });
          setDivGroupList(response.data);
        } catch (error) {
          console.error("Error fetching Division Group:", error);
        }  finally {
          setLoading(false);  // ✅ Ensure this is executed after fetch
        }
      };
      fetchDivGroup();
    }
  }, [selectedEntity]);

  useEffect(() => {
    if (selectedEntity && selectedFinYear && selectedDivGroup) {
      const fetchPOSeries = async () => {
        try {
          setLoading(true);
          const response = await axios.post("/api/frght/getPOSeries", {
            entity_code: selectedEntity,
            finyr: selectedFinYear,
            div_group: selectedDivGroup,
            emp_id,
            token
          });
          setPoSeriesList(response.data);
        } catch (error) {
          console.error("Error fetching PO series:", error);
        }  finally {
          setLoading(false);  // ✅ Ensure this is executed after fetch
        }
      };
      fetchPOSeries();
    }
  }, [selectedEntity, selectedFinYear, selectedDivGroup]);

  useEffect(() => {
    if (selectedEntity && selectedFinYear && selectedSeries && fromDate && toDate) {
      const fetchPoNumbers = async () => {
        try {
          setLoading(true);
          const response = await axios.post("/api/frght/getPODetails", {
            entity_code: selectedEntity,
            series: selectedSeries,
            from_date: formatDate(fromDate),
            to_date: formatDate(toDate),
            trpt: selectedTrptCode,
            emp_id
          });
          setPoNumbers(response.data||[]);
        } catch (error) {
          console.error("Error fetching PO numbers:", error);
        }  finally {
          setLoading(false);  // ✅ Ensure this is executed after fetch
        }
      };
      fetchPoNumbers();
    }
  }, [selectedEntity, selectedFinYear, selectedSeries, fromDate, toDate]);

  useEffect(() => {
    setFreightOrderList([]);
    if (selectedPo) {
      const fetchFrghtOrders = async () => {
        try {
          setLoading(true);
          const response = await axios.post("/api/frght/getFrghtOrders", {
            entity_code: selectedPo?.ENTITY_CODE,
            order_tcode: selectedPo?.TCODE,
            order_vrno: selectedPo?.VRNO,
            order_amendno: selectedPo?.AMENDNO,
            emp_id,
          });
          setFreightOrderList(response.data || []);
          setSelectedFreightOrder(null);
        } catch (err) {
          console.error("Error fetching freight orders", err);
        }
      };
      fetchFrghtOrders();
      setLoading(false);
    }
  }, [selectedPo, selectedEntity]);
  
  const truncateTime = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
  };

  useEffect(() => {
    applyDateFilter();
  }, [hideLinked]);

  useEffect(() => {
    applyDateFilter();
  }, [grns, hideBilled, filterFromDate, filterToDate]);
  
  useEffect(() => {
    applyDateFilter();
  }, [showLocationErrorsOnly, showTruckTypeErrorsOnly, showUnlinkedErrorsOnly]);
  
  useEffect(() => {
    const start = (currentPage - 1) * recordsPerPage;
    const end = start + recordsPerPage;
    setPaginatedGrns(filteredGrns.slice(start, end));
  }, [filteredGrns, currentPage]);
    
  useEffect(() => {
    setGrns([]); // Clear GRNs first
    if (selectedPo && selectedFreightOrder) {
      const fetchGrns = async () => {
        try {
          setLoading(true);
          const response = await axios.post("/api/frght/getGrnsToLink", {
            entity_code: selectedEntity,
            order_tcode: selectedPo?.TCODE,
            order_vrno: selectedPo?.VRNO,
            order_amendno: selectedPo?.AMENDNO,
            trpt_code: selectedFreightOrder?.TRPT_CODE,
            from_date: formatDate(selectedFreightOrder?.FROM_DATE),
            to_date:formatDate(selectedFreightOrder?.TO_DATE),
            emp_id,
          });
          setGrns(response.data);
          //setShowAllGrns(true); // Automatically switch to Show All mode
        } catch (err) {
          console.error("Error fetching GRNs:", err);
        }  finally {
          setLoading(false);  // ✅ Ensure this is executed after fetch
        }
      };
      fetchGrns();
    }
  }, [selectedPo, selectedFreightOrder]);
  
  useEffect(() => {
    //console.log("GRNs updated:", grns);
    applyDateFilter();
  }, [grns]);

  useEffect(() => {
    const start = (currentPage - 1) * recordsPerPage;
    const end = start + recordsPerPage;
    setPaginatedGrns(filteredGrns.slice(start, end));
  }, [filteredGrns, currentPage, recordsPerPage]);

  useEffect(() => {
    if (loadingSelection) {
      // Once selectedGrns updates, disable loading
      console.log("selectedGrns", selectedGrns);
      setLoadingSelection(false);
    }
  }, [selectedGrns]);
  

  /*
  const applyDateFilter = () => {
    const fromPlace = selectedFreightOrder?.FROM_PLACE;
    const toPlace = selectedFreightOrder?.TO_PLACE;
  
    const filtered = grns.filter(grn => {
      const isNotBilled = hideBilled ? !grn.ACC_VRNO : true;
      const isUnlinked = hideLinked ? !grn.FREIGHT_ORDER_VRNO : true;
  
      let dateToCompare = null;
  
      if (grn.WAYBILL_DATE) {
        dateToCompare = truncateTime(new Date(grn.WAYBILL_DATE));
      } else if (grn.INDATE) {
        dateToCompare = truncateTime(new Date(grn.INDATE));
      }
  
      const waybillFrom = filterFromDate ? truncateTime(new Date(filterFromDate)) : null;
      const waybillTo = filterToDate ? truncateTime(new Date(filterToDate)) : null;
      const inFrom = filterInFromDate ? truncateTime(new Date(filterInFromDate)) : null;
      const inTo = filterInToDate ? truncateTime(new Date(filterInToDate)) : null;
  
      const matchWaybill = (!waybillFrom || dateToCompare >= waybillFrom) &&
                           (!waybillTo || dateToCompare <= waybillTo);
  
      const matchInDate = (!inFrom || dateToCompare >= inFrom) &&
                          (!inTo || dateToCompare <= inTo);
  
      const hasLocationMismatch = grn.FROM_PLACE !== fromPlace || grn.TO_PLACE !== toPlace;
      const hasTruckTypeMissing = !!grn.TRUCKTYPE_NAME;
      const isActuallyUnlinked = !grn.FREIGHT_ORDER_VRNO;
  
      // 🔀 If any specific toggle is active, return only those
      if (showLocationErrorsOnly) {
        return hasLocationMismatch && matchWaybill && matchInDate && isNotBilled;
      }
      if (showTruckTypeErrorsOnly) {
        return hasTruckTypeMissing && matchWaybill && matchInDate && isNotBilled;
      }
      if (showUnlinkedErrorsOnly) {
        return isActuallyUnlinked && matchWaybill && matchInDate && isNotBilled;
      }
  
      // Default mode
      return matchWaybill && matchInDate && isNotBilled && isUnlinked;
    });
  
    setFilteredGrns(filtered);
    setCurrentPage(1);
  };
  const clearDateFilter = () => {
    setFilterFromDate("");
    setFilterToDate("");
    setFilterInFromDate("");
    setFilterInToDate("");    
    setHideBilled(false);
    setFilteredGrns(grns);
  };
  */
  const applyDateFilter = () => {
    const fromPlace = selectedFreightOrder?.FROM_PLACE;
    const toPlace = selectedFreightOrder?.TO_PLACE;
    const query = searchText.trim().toLowerCase();
  
    const filtered = grns.filter(grn => {
      const isNotBilled = hideBilled ? !grn.ACC_VRNO : true;
      const isUnlinked = hideLinked ? !grn.FREIGHT_ORDER_VRNO : true;
  
      let dateToCompare = null;
      if (grn.WAYBILL_DATE) {
        dateToCompare = truncateTime(new Date(grn.WAYBILL_DATE));
      } else if (grn.INDATE) {
        dateToCompare = truncateTime(new Date(grn.INDATE));
      }
  
      const waybillFrom = filterFromDate ? truncateTime(new Date(filterFromDate)) : null;
      const waybillTo = filterToDate ? truncateTime(new Date(filterToDate)) : null;
      const inFrom = filterInFromDate ? truncateTime(new Date(filterInFromDate)) : null;
      const inTo = filterInToDate ? truncateTime(new Date(filterInToDate)) : null;
  
      const matchWaybill = (!waybillFrom || dateToCompare >= waybillFrom) &&
                           (!waybillTo || dateToCompare <= waybillTo);
  
      const matchInDate = (!inFrom || dateToCompare >= inFrom) &&
                          (!inTo || dateToCompare <= inTo);
  
      const hasLocationMismatch = grn.FROM_PLACE !== fromPlace || grn.TO_PLACE !== toPlace;
      const hasTruckTypeMissing = !!grn.TRUCKTYPE_NAME;
      const isActuallyUnlinked = !grn.FREIGHT_ORDER_VRNO;
  
      const matchesSearch = !query || (
        (grn.WSLIPNO || '').toString().toLowerCase().includes(query) ||
        (grn.VRNO || '').toString().toLowerCase().includes(query) ||
        (grn.TP_PAGE || '').toString().toLowerCase().includes(query) ||
        (grn.WAYBILLNO || '').toString().toLowerCase().includes(query)
      );
  
      // 🔀 Toggle filter priority
      if (showLocationErrorsOnly) {
        return hasLocationMismatch && matchWaybill && matchInDate && isNotBilled && matchesSearch;
      }
      if (showTruckTypeErrorsOnly) {
        return hasTruckTypeMissing && matchWaybill && matchInDate && isNotBilled && matchesSearch;
      }
      if (showUnlinkedErrorsOnly) {
        return isActuallyUnlinked && matchWaybill && matchInDate && isNotBilled && matchesSearch;
      }
  
      // Default filter mode
      return matchWaybill && matchInDate && isNotBilled && isUnlinked && matchesSearch;
    });
  
    setFilteredGrns(filtered);
    setCurrentPage(1);
  };

  const clearDateFilter = () => {
    setFilterFromDate("");
    setFilterToDate("");
    setFilterInFromDate("");
    setFilterInToDate("");
    setSearchText("");
    setHideBilled(false);
    setFilteredGrns(grns);
  };
    
  const showGrnErrors = () => {
    if (!selectedFreightOrder) {
      alert("Please select a freight order first.");
      return;
    }
    let locationMismatch = 0;
    let dateOutOfRange = 0;
    let truckTypeMissing = 0;
    let unlinkedGrns = 0;
  
    const fromDate = selectedFreightOrder?.FROM_DATE ? new Date(selectedFreightOrder.FROM_DATE) : null;
    const toDate = selectedFreightOrder?.TO_DATE ? new Date(selectedFreightOrder.TO_DATE) : null;

    filteredGrns.forEach(grn => {
      //console.log("miss places:", grn.FROM_PLACE,selectedFreightOrder.FROM_PLACE,grn.TO_PLACE, selectedFreightOrder.TO_PLACE );
      // 1. Location mismatch
      if (
        grn.FROM_PLACE !== selectedFreightOrder.FROM_PLACE ||
        grn.TO_PLACE !== selectedFreightOrder.TO_PLACE
      ) locationMismatch++;
  
      // 2. GRN date not in order date range
      const grnDate = grn.WAYBILL_DATE ? new Date(grn.WAYBILL_DATE) : null;
      if (grnDate && fromDate && toDate) {
        if (grnDate < fromDate || grnDate > toDate) dateOutOfRange++;
      }
  
      // 3. Truck type missing
      if (grn.TRUCKTYPE) truckTypeMissing++;

      // 4. Unlinked GRNs (any of the 3 fields missing or falsy)
      if (
        !grn.FREIGHT_ORDER_VRNO ||
        !grn.FREIGHT_ORDER_TCODE ||
        !grn.FREIGHT_ORDER_SLNO
      ) {
        unlinkedGrns++;
      }      
    });
  
    setGrnErrorSummary({ locationMismatch, dateOutOfRange, truckTypeMissing, unlinkedGrns });
    setShowErrorsModal(true);
  };
   
  const handleGrnSelection = (grn) => {
    console.log("Clicked-1a:", grn.VRNO);
    console.log("Stage--1a", selectedGrns);
    setLoadingSelection(true);  

    setSelectedGrns((prevSelected) => {
      const alreadySelected = prevSelected.find(item => item.VRNO === grn.VRNO);
      console.log("ALreadydelecte Stage--1c",alreadySelected);
      if (alreadySelected) {
        console.log("Stage--1c- at alreadyselected",alreadySelected);
        return prevSelected.filter(item => item.VRNO !== grn.VRNO);
      } else {
        // Add necessary fields (expand as needed)
        console.log("Stage--1c- at not alreadyselected",alreadySelected);
        return [
          ...prevSelected,
          {
            ENTITY_CODE: grn.ENTITY_CODE,
            TCODE: grn.TCODE,
            VRNO: grn.VRNO,
            SLNO: grn.SLNO,
            AMENDNO: grn.AMENDNO,
            TRPT_CODE: grn.TRPT_CODE
          }
        ];
      }
    });
    console.log("Stage--1b");
    console.log(selectedGrns);
    console.log("Stage--2b");
  };

  const handleLinkGrns = async () => {
    if (selectedGrns.length === 0) {
      alert("Please select at least one GRN to link.");
      return;
    }
    try {
      await axios.post("/api/frght/linkGrns", {
        frightOrder: selectedFreightOrder,
        grns: selectedGrns,
        emp_id,
        token
      });
      alert("GRNs linked successfully!");
      setSelectedGrns([]);
      setGrns([]);
    } catch (error) {
      console.error("Error linking GRNs:", error);
      alert("Failed to link GRNs.");
    }
  };

  const handleUpdateLoc = async () => {
    if (selectedGrns.length === 0) {
      alert("Please select at least one GRN to update Location");
      return;
    }
    try {
      await axios.post("/api/frght/updateLocation", {
        frightOrder: selectedFreightOrder,
        grns: selectedGrns,
        emp_id,
        token
      });
      alert("✔ Location of Selected GRNs updated succefully!");
      setSelectedGrns([]);
      setGrns([]);
    } catch (error) {
      console.error("Error linking GRNs:", error);
      alert("Failed to link GRNs.");
    }
  };

  const handleTruckType = async () => {
    if (selectedGrns.length === 0) {
      alert("Please select at least one GRN to update Truck Type");
      return;
    }
    try {
      await axios.post("/api/frght/updateTruckType", {
        grns: selectedGrns,
        emp_id,
        token
      });
      alert("GRNs linked successfully!");
      setSelectedGrns([]);
      setGrns([]);
    } catch (error) {
      console.error("Error linking GRNs:", error);
      alert("Failed to link GRNs.");
    }
  };

  const handleLocation = async () => {
    if (selectedGrns.length === 0) {
      alert("Please select at least one GRN to update Truck Type");
      return;
    }
    try {
      await axios.post("/api/frght/updateLocation", {
        frightOrder: selectedFreightOrder,
        grns: selectedGrns,
        emp_id,
        token
      });
      alert("GRNs linked successfully!");
      setSelectedGrns([]);
      setGrns([]);
    } catch (error) {
      console.error("Error linking GRNs:", error);
      alert("Failed to link GRNs.");
    }
  };

  const handleSelectAllFiltered = () => {
    const selectable = filteredGrns.filter(grn =>
      isGrnSelectable(grn) &&
      !selectedGrns.some(item => item.VRNO === grn.VRNO)
    );
  
    const newSelections = selectable.map(grn => ({
      ENTITY_CODE: grn.ENTITY_CODE,
      TCODE: grn.TCODE,
      VRNO: grn.VRNO,
      SLNO: grn.SLNO,
      AMENDNO: grn.AMENDNO,
      TRPT_CODE: grn.TRPT_CODE
}));
  
    setSelectedGrns(prev => [...prev, ...newSelections]);
    console.log("Stage--2");
    console.log(selectedGrns);
    console.log("Stage--2");

  };

  const handleDeselectAllFiltered = () => {
    const remaining = selectedGrns.filter(
      grn => !filteredGrns.some(
        fg => fg.VRNO === grn.VRNO && isGrnSelectable(fg)
      )
    );
    setSelectedGrns(remaining);
    console.log("Stage--3");
    console.log(selectedGrns);
    console.log("Stage--3");

  };
      
  const goToPage = (page) => {
    const safePage = Math.max(1, Math.min(page, totalPages));
    setCurrentPage(safePage);
  };
  
  // 🔽 Place it here — just before the return (or JSX block)
  const totalPages = Math.ceil(filteredGrns.length / recordsPerPage);
  const totalRecords = filteredGrns.length;
  const totalQtyChallan = filteredGrns.reduce((sum, row) => sum + (Number(row.NETWT) || 0), 0);
  const totalQtyRecd = filteredGrns.reduce((sum, row) => sum + (Number(row.QTYRECD) || 0), 0);
  const totalReachedQty = filteredGrns.reduce((sum, row) => sum + (Number(row.REACHEDQTY) || 0), 0);
  const totalIssuedQty = filteredGrns.reduce((sum, row) => sum + (Number(row.QTYISSUED) || 0), 0);

  if (!token) {
    return (
      <div>
        <p>You must be logged in to print daily attendance.</p>
        <button onClick={() => navigate("/")}>Go to Login</button>
      </div>
    );
  }
    
  return (
    <Container className="link-grn-form small-font">
      {loading && (
        <div className="loading-overlay">
          <div className="spinner-border text-primary" role="status" />
        </div>
      )}

      <h5 className="mt-2 mb-1" >Link GRNs to Freight Order</h5>

      <Row className="mb-1 g-1" >
        <Col md={3}>
          <Form.Label>Entity</Form.Label>
          <Form.Control as="select" value={selectedEntity} onChange={e => setSelectedEntity(e.target.value)}>
            <option value="">-- Select --</option>
            {entityList.map(e => (
              <option key={e.ENTITY_CODE} value={e.ENTITY_CODE}>
                {e.ENTITY_CODE} - {e.ENTITY_NAME}
              </option>
            ))}
          </Form.Control>
        </Col>
        <Col md={3}>
          <Form.Label>Fin. Year</Form.Label>
          <Form.Control as="select" value={selectedFinYear} onChange={e => setSelectedFinYear(e.target.value)}>
            <option value="">-- Select --</option>
            {finYearList.map(y => (
              <option key={y.ACC_YEAR} value={y.ACC_YEAR}>
                {y.ACC_YEAR} ({y.YRBEGDATE?.slice(0, 10)} to {y.YRENDDATE?.slice(0, 10)})
              </option>
            ))}
          </Form.Control>
        </Col>
        <Col md={3}>
          <Form.Label>Div Group</Form.Label>
          <Form.Control as="select" value={selectedDivGroup} onChange={e => setSelectedDivGroup(e.target.value)}>
            <option value="">-- Select --</option>
            {divGroupList.map(d => (
              <option key={d.DIV_GROUP} value={d.DIV_GROUP}>
                {d.DIV_GROUP} - {d.DIV_GROUP_NAME}
              </option>
            ))}
          </Form.Control>
        </Col>
        <Col md={3}>
          <Form.Label>PO Series</Form.Label>
          <Form.Control as="select" value={selectedSeries} onChange={e => setSelectedSeries(e.target.value)}>
            <option value="">-- Select --</option>
            {poSeriesList.map(s => (
              <option key={s.SERIES} value={s.SERIES}>
                {s.SERIES}-{s.BHEADING}
              </option>
            ))}
          </Form.Control>
        </Col>
      </Row>

      <Row className="mb-1 g-1" >
      <Col md={3}>
        <Form.Label>Transporter</Form.Label>
        <Select
          className="react-select-container"
          classNamePrefix="react-select"
          options={trptCodeList.map(trptCode => ({
            value: trptCode.ACC_CODE,
            label: `${trptCode.ACC_CODE}-${trptCode.ACC_NAME}-${trptCode.ADD1}-${trptCode.CITY}`
          }))}
          value={selectedTrptCode ? {
            value: selectedTrptCode.ACC_CODE,
            label: `${selectedTrptCode.ACC_CODE}-${selectedTrptCode.ACC_NAME}-${selectedTrptCode.ADD1}-${selectedTrptCode.CITY}`
          } : null}
          onChange={(selectedOption) => {
            const selected = trptCodeList.find(trpt =>
              trpt.ACC_CODE === selectedOption?.value
            );
            setSelectedTrptCode(selected);
          }}
          isSearchable
          placeholder="Select Transporter"
        />
      </Col>
        <Col md={3}>
          <Form.Label className="mb-1">Billing Period</Form.Label>
          <Row className="g-2">
            <Col>
              <Form.Group controlId="fromDate">
                <DatePicker
                  selected={fromDate}
                  onChange={(date) => setFromDate(date)}
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Select From Date"
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="toDate">
                <DatePicker
                  selected={toDate}
                  onChange={(date) => setToDate(date)}
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Select To Date"
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>

        <Col md={3}>
          <Form.Label>PO Number</Form.Label>
          <Select
            className="react-select-container"
            classNamePrefix="react-select"
            options={poNumbers.map(po => ({
              value: `${po.VRNO}|${po.AMENDNO}`,
              label: `${po.VRNO}-${po.AMENDNO}-${po.PARTYREFNO}-${po.ACC_NAME}`
            }))}
            value={selectedPo ? {
              value: `${selectedPo.VRNO}|${selectedPo.AMENDNO}`,
              label: `${selectedPo.VRNO}-${selectedPo.AMENDNO}-${selectedPo.PARTYREFNO}-${selectedPo.ACC_NAME}`
            } : null}
            onChange={(selectedOption) => {
              const [vrno, amendno] = selectedOption?.value.split("|");
              const selected = poNumbers.find(po =>
                po.VRNO === vrno && String(po.AMENDNO) === amendno
              );
              setSelectedPo(selected);
            }}
            isSearchable
            placeholder="Select PO Number"
          />
        </Col>
        <Col md={3}>
          <Form.Label>Freight Order</Form.Label>
          <Form.Control
            as="select"
            value={selectedFreightOrder?.VRNO || ""}
            onChange={(e) => {
              const selected = freightOrderList.find((fo) => fo.VRNO === e.target.value);
              setSelectedFreightOrder(selected);
            }}
            disabled={!freightOrderList.length}
          >
            <option value="">-- Select Freight Order --</option>
            {freightOrderList.map((fo) => (
              <option key={fo.VRNO} value={fo.VRNO}>
                {`${fo.VRNO}`}-{`${fo.ACC_NAME}`}
              </option>
            ))}
          </Form.Control>
        </Col>
      </Row>

      <FreightSummaryCard selectedFreightOrder={selectedFreightOrder} billFromDate={fromDate} billToDate={toDate} />
  <>
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-2 mb-2 px-1 flex-wrap gap-2 border rounded p-2 bg-light">
    {/* Title */}
    {/* Show All / Unlinked Toggle & Link Button */}
    <div className="d-flex flex-wrap align-items-center gap-2">
      <Form.Check
        type="switch"
        id="billed-switch"
        label="Hide Billed"
        checked={hideBilled}
        onChange={(e) => setHideBilled(e.target.checked)}
        className="mb-0"
      />      
      <Form.Check
        type="switch"
        id="linked-switch"
        label="Hide Linked"
        checked={hideLinked}
        onChange={(e) => setHideLinked(e.target.checked)}
        className="mb-0"
      />

      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-errors">Show GRN Errors</Tooltip>}
      >
        <Button variant="danger" size="sm" onClick={showGrnErrors} className="ms-2">
          <i className="bi bi-exclamation-triangle-fill"></i>
        </Button>
      </OverlayTrigger>
      <Card className="py-2 mt-1 mb-1 bg-light border" 
        style={{ paddingLeft: "1.5rem", paddingRight: "1.5rem", minHeight: "55px" }}>
        <Card.Title className="mb-2" style={{ fontSize: "0.7rem" }}>
          GRN Filters & Error Toggles
        </Card.Title>

        <div className="d-flex flex-wrap align-items-center gap-3">
          <Form.Check
            type="switch"
            id="unlinked-switch"
            label="Unlinked"
            checked={showUnlinkedErrorsOnly}
            onChange={(e) => {
              setSelectedGrns([]); // ❗ Clear selection
              setShowUnlinkedErrorsOnly(e.target.checked);
              if (e.target.checked) {
                setShowLocationErrorsOnly(false);
                setShowTruckTypeErrorsOnly(false);
              }
            }}            
          />

          <Form.Check
            type="switch"
            id="loc-switch"
            label="Location"
            checked={showLocationErrorsOnly}
            onChange={(e) => {
              setShowLocationErrorsOnly(e.target.checked);
              if (e.target.checked) {
                setShowUnlinkedErrorsOnly(false);
                setShowTruckTypeErrorsOnly(false);
              }
            }}
          />

          <Form.Check
            type="switch"
            id="truck-switch"
            label="Truck Type"
            checked={showTruckTypeErrorsOnly}
            onChange={(e) => {
              setSelectedGrns([]); // ❗ Clear selection
              setShowTruckTypeErrorsOnly(e.target.checked);
              if (e.target.checked) {
                setShowLocationErrorsOnly(false);
                setShowUnlinkedErrorsOnly(false);
              }
            }}                        
          />
        </div>
      </Card>
      <Card
        className="px-3 py-1 mt-1 mb-1 pe-2 border border-success bg-light"
        style={{ 
          padding: "6px 1rem",  // top-bottom: 6px, left-right: 1rem (~16px)
          minHeight: "55px" }}   /* drop if not needed */
      >
        {/* tiny header line */}
        <div
          className="d-flex align-items-center justify-content-between mb-1"
          style={{ fontSize: "0.7rem", color: "#155724" }}
        >
          <div className="d-flex align-items-center">
            <div className="me-1">Selected GRNs:</div>
            <strong>{selectedGrns.length}</strong>
          </div>
        </div>

        {/* action buttons */}
        <div className="d-flex flex-wrap align-items-center gap-2">
          <OverlayTrigger placement="top" overlay={<Tooltip>Select all filtered GRNs</Tooltip>}>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={handleSelectAllFiltered}
              style={{ padding: "2px 6px" }}
              className="ms-2"
            >
              <i className="bi bi-check2-square" />
            </Button>
          </OverlayTrigger>

          <OverlayTrigger placement="top" overlay={<Tooltip>Deselect all filtered GRNs</Tooltip>}>
            <Button
              variant="outline-danger"
              size="sm"
              onClick={handleDeselectAllFiltered}
              style={{ padding: "2px 6px" }}
            >
              <i className="bi bi-x-square" />
            </Button>
          </OverlayTrigger>

          <OverlayTrigger placement="top" overlay={<Tooltip>Update From/To location</Tooltip>}>
            <Button variant="info" size="sm" disabled={loadingSelection} onClick={handleLocation} style={{ padding: "2px 6px" }}>
              <i className="bi bi-geo-alt-fill" />
            </Button>
          </OverlayTrigger>

          <OverlayTrigger placement="top" overlay={<Tooltip>Update truck type</Tooltip>}>
            <Button variant="dark" size="sm" disabled={loadingSelection} onClick={handleTruckType} style={{ padding: "2px 6px" }}>
              <i className="bi bi-truck" />
            </Button>
          </OverlayTrigger>

          <OverlayTrigger placement="top" overlay={<Tooltip>Link selected GRNs</Tooltip>}>
            <Button variant="success" size="sm" disabled={loadingSelection} onClick={handleLinkGrns} style={{ padding: "2px 6px" }}>
              <i className="bi bi-link-45deg" />
            </Button>
          </OverlayTrigger>
        </div>
      </Card>

    </div>

    {/* Pagination Controls */}
    <div className="d-flex align-items-center gap-2 mt-2 mt-md-0">
      <Button size="sm" variant="outline-secondary" onClick={() => goToPage(1)} disabled={currentPage === 1}>⏮ </Button>
      <Button size="sm" variant="outline-secondary" onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>◀ </Button>
      <span style={{ fontSize: '0.75rem' }}>Page {currentPage} of {totalPages}</span>
      <Button size="sm" variant="outline-secondary" onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}> ▶</Button>
      <Button size="sm" variant="outline-secondary" onClick={() => goToPage(totalPages)} disabled={currentPage === totalPages}> ⏭</Button>

      <Form.Select
        size="sm"
        value={recordsPerPage}
        onChange={e => {
          setRecordsPerPage(parseInt(e.target.value));
          setCurrentPage(1);
        }}
        style={{ width: "80px", fontSize: "0.75rem" }}
      >
        {[10, 20, 50, 100].map(n => (
          <option key={n} value={n}>{n}/page</option>
        ))}
      </Form.Select>
    </div>
    </div>
    {/* 🔹 Compact One-Line Filter Row */}
    <div className="d-flex flex-wrap align-items-center gap-2 mb-2 bg-light p-2 rounded border">

      {/* Waybill Date Filter */}
      <div className="d-flex align-items-center gap-1">
        <strong className="me-1">Waybill:</strong>
        <input
          type="date"
          className="form-control form-control-sm"
          value={filterFromDate}
          onChange={(e) => setFilterFromDate(e.target.value)}
          style={{ width: "140px" }}
        />
        <span className="mx-1">to</span>
        <input
          type="date"
          className="form-control form-control-sm"
          value={filterToDate}
          onChange={(e) => setFilterToDate(e.target.value)}
          style={{ width: "140px" }}
        />
      </div>

      {/* In-Date Filter */}
      <div className="d-flex align-items-center gap-1 ms-3">
        <strong className="me-1">In-Date:</strong>
        <input
          type="date"
          className="form-control form-control-sm"
          value={filterInFromDate}
          onChange={(e) => setFilterInFromDate(e.target.value)}
          style={{ width: "140px" }}
        />
        <span className="mx-1">to</span>
        <input
          type="date"
          className="form-control form-control-sm"
          value={filterInToDate}
          onChange={(e) => setFilterInToDate(e.target.value)}
          style={{ width: "140px" }}
        />
      </div>
      <div className="d-flex align-items-center gap-1 ms-3">
        <Form.Control
          size="sm"
          type="text"
          placeholder="Search WSLIPNO / VRNO / TP_PAGE / WAYBILLNO"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="me-2"
          style={{ maxWidth: "280px" }}
        />
      </div>

      {/* Buttons */}
      <div className="d-flex align-items-center ms-3">
        <button className="btn btn-sm btn-primary me-2" onClick={applyDateFilter}>
          <i className="bi bi-funnel-fill me-1"></i> Filter
        </button>
        <button className="btn btn-sm btn-secondary" onClick={clearDateFilter}>
          <i className="bi bi-x-circle-fill me-1"></i> Clear
        </button>
      </div>
    </div>

    <div className="table-responsive-scroll">
      <Table striped bordered hover size="sm" className="mt-2">
        <thead>
          <tr>
            <th>Select</th>
            <th>GRN No</th>
            <th>GRN Date</th>
            <th>SLNO</th>
            <th>Item Code</th>
            <th>TruckNo</th>
            <th>TruckType</th>
            <th>LRNO</th>
            <th>LR Date</th>
            <th>From Place</th>
            <th>To Place</th>
            <th>Tp Page</th>
            <th>WayBillNo</th>
            <th>WayBillDT</th>
            <th>WSLIPNO</th>
            <th>GATE VRNO</th>
            <th>In Date</th>          
            <th>Challan Qty</th>
            <th>Reache Qty</th>
            <th>Qty Recvd</th>
            <th>Qty Issued</th>
            <th>Item Name</th>
            <th>Fr.Ord Tcode</th>
            <th>Fr.Ord VRNO</th>
            <th>Fr.Ord Slno</th>
            <th>Fr.Ord Amendno</th>
            <th>BillPassed</th>
          </tr>
        </thead>
        <tbody>
          {paginatedGrns.map(grn => {
            const selectable = isGrnSelectable(grn);
            const isUnlinked = selectable && !grn.ACC_VRNO; 

            const tdStyle = !!grn.ACC_VRNO
                            ? { color: "blue" }
                            : isGrnSelectable(grn)
                            ? { color: "darkorange" }
                            : {};                            
            return (
              <tr key={`${grn.ENTITY_CODE}-${grn.TCODE}-${grn.VRNO}-${grn.SLNO}`}>
                <td style={tdStyle}>
                <Form.Check
                  type="checkbox"
                  checked={selectedGrns.some(item => item.VRNO === grn.VRNO)}
                  onChange={() => {
                    console.log("Clicked:", grn.VRNO);
                    handleGrnSelection(grn);
                  }}
                  disabled={!isUnlinked  || !!grn.ACC_VRNO}
                />              
                </td>
                <td style={tdStyle}>{grn.VRNO}</td>
                <td style={tdStyle}>{grn.VRDATE_STR}</td>
                <td style={tdStyle}>{grn.SLNO}</td>
                <td style={tdStyle}>{grn.ITEM_CODE}</td>
                <td style={tdStyle}>{grn.TRUCKNO}</td>
                <td style={tdStyle}>{grn.TRUCKTYPE_NAME}</td>
                <td style={tdStyle}>{grn.LRNO}</td>
                <td style={tdStyle}>{grn.LRDATE}</td>
                <td style={tdStyle}>{grn.FROM_PLACE}</td>
                <td style={tdStyle}>{grn.TO_PLACE}</td>
                <td style={tdStyle}>{grn.TP_PAGE_NO}</td>
                <td style={tdStyle}>{grn.WB_NO}</td>
                <td style={tdStyle}>{grn.WAYBILL_DATE_STR}</td>
                <td style={tdStyle}>{grn.WSLIPNO}</td>
                <td style={tdStyle}>{grn.GATE_VRNO}</td>
                <td style={tdStyle}>{grn.INDATE_STR}</td>
                <td style={tdStyle}>{grn.NETWT}</td>
                <td style={tdStyle}>{grn.REACHEDQTY}</td>
                <td style={tdStyle}>{grn.QTYRECD}</td>
                <td style={tdStyle}>{grn.QTYISSUED}</td>
                <td style={tdStyle}>{grn.ITEM_NAME}</td>
                <td style={tdStyle}>{grn.FREIGHT_ORDER_TCODE}</td>
                <td style={tdStyle}>{grn.FREIGHT_ORDER_VRNO}</td>
                <td style={tdStyle}>{grn.FREIGHT_ORDER_SLNO}</td>
                <td style={tdStyle}>{grn.FREIGHT_ORDER_AMENDNO}</td>
                <td style={tdStyle}>{grn.ACC_VRNO}</td>               
              </tr>
            );
          })}
        </tbody>

        <tfoot>
          <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td colSpan="2"><strong>Total Records:</strong> {totalRecords}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{totalQtyChallan.toFixed(2)}</td>
              <td>{totalQtyRecd.toFixed(2)}</td>
              <td>{totalReachedQty.toFixed(2)}</td>
              <td>{totalIssuedQty.toFixed(2)}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
          </tr>
        </tfoot>      
      </Table>
      <Modal show={showErrorsModal} onHide={() => setShowErrorsModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>GRN Error Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <p><strong>🔗 UnLinked GRNs:</strong> {grnErrorSummary.unlinkedGrns}</p>
          <p><strong>🔁 Location Mismatches:</strong> {grnErrorSummary.locationMismatch}</p>
          <p><strong>📅 Date Out of Range:</strong> {grnErrorSummary.dateOutOfRange}</p>
          <p><strong>🚚 Missing Truck Type:</strong> {grnErrorSummary.truckTypeMissing}</p>
          <p><strong>🚚 Freight Basis Issues:</strong> This feature yet to add</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowErrorsModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  </>
    </Container>

  );
};


export default LinkGrnToFreightOrder;
